import { CollapsibleContentCard, LargeTitle, palettes, Status } from '@indigo-ag/component-module';
import { FeedbackVariants } from '@indigo-ag/component-module/dist/commonjs/shared/theme/theme-helpers/feedback';
import React from 'react';
import { SerasaAnnotationCard } from '../../components/BackgroundCheck/SerasaBacen/Serasa/SerasaAnnotationCard';
import i18next from 'i18next';
import styled from 'styled-components';
import { NoContactsFound } from 'shared/components/NoResultsFound/NoContactsFounds';
import { SerasaBacenItem, SerasaBacenStatus } from '../Phase1.utils';
import { BacenAnnotationCard } from '../../components/BackgroundCheck/SerasaBacen/Bacen/BacenAnnotationCard';

interface SerasaBacenSectionProps {
  serasaBacenList: SerasaBacenItem[];
}

const Container = styled.div`
  > div {
    margin-bottom: 16px;
  }
`;

const CardsContainer = styled.div`
  column-gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const getStatusTranslation = (status: SerasaBacenStatus) => {
  return i18next.t(`serasaApiStatus_${status}`);
};

const VARIANT_STATUS: Record<SerasaBacenStatus, FeedbackVariants> = {
  CLEARED: 'success',
  FAILED: 'error',
  UNRESOLVED: 'warning'
};

export const SerasaBacenSection = ({ serasaBacenList }: SerasaBacenSectionProps) => {
  if (serasaBacenList.length === 0) return <NoContactsFound />;

  return (
    <Container>
      <LargeTitle style={{ marginBottom: '16px', color: palettes.brand.blue.base }}>
        {serasaBacenList[0].bacen ? i18next.t('preAnalysisSerasaBacen') : i18next.t('preAnalysisSerasa')}
      </LargeTitle>
      {serasaBacenList.map(item => (
        <CollapsibleContentCard
          key={item.contactName}
          titleText={item.contactName}
          renderAfterTitle={() => (
            <Status label={getStatusTranslation(item.overallStatus)} variant={VARIANT_STATUS[item.overallStatus]} />
          )}
        >
          <CardsContainer>
            {!item.bacen && !item.serasa && i18next.t('serasaBacenReport_notAvailable')}
            {item.serasa && (
              <SerasaAnnotationCard annotationType={i18next.t('serasaAnnotationCard_title')} report={item.serasa} />
            )}
            {item.bacen && (
              <BacenAnnotationCard annotationType={i18next.t('bacenAnnotationCard_title')} report={item.bacen} />
            )}
          </CardsContainer>
        </CollapsibleContentCard>
      ))}
    </Container>
  );
};
